import {
  Category,
  Feedback,
  Filter,
  GELocation,
  Issue,
  ITaskShareObj,
  ITempTaskWithNewStoplight,
  SCLocation
} from '../../config/interfaces';
import { ISaveTaskModalStatePayload } from '../actions';

/**
 * Store sub context for task data
 */
const TaskContext = {
  loadingPostNewTask: false,
  loadingCompleteTask: false,
  loadingDeleteTask: false,
  sharingQ: [] as ITaskShareObj[],
  sharing: false,
  categories: [] as Category[],
  selectedData: null as Feedback | null,
  patientTasks: [] as (Issue | Feedback)[],
  searchedIssues: [] as Issue[],
  tempTaskObject: {} as ITempTaskWithNewStoplight,
  tempModalState: {} as ISaveTaskModalStatePayload,
  ticketDetails: '',
  isLoadingTicket: false,
  scLocations: [] as SCLocation[],
  isLoadingSCLocations: false,
  geLocations: [] as GELocation[],
  isLoadingGELocations: false,
  controlNumberResponse: null as string | null,
  isLoadingControlNumber: false,
  issues: [] as Issue[],
  loadingIssuesByUnitIdsOrEmployeeList: false,
  loadingIssuesByFacility: false,
  currentIssuePage: 1,
  issueFilter: {} as Filter,
  feedback: [] as Feedback[],
  loadingFeedbackByUnitIds: false,
  loadingFeedbackByEmployeeList: false,
  loadingFeedbackByFacility: false,
  currentFeedbackPage: 1,
  taskSearchQuery: '',
  feedbackFilter: {} as Filter,
  sortKey: 'created',
  sortDir: 'desc',
  totalCount: 0,
  issueMetrics: {
    totalRecordsCount: 0,
    completedRecordsCount: 0,
    openedRecordsCount: 0
  },
  recognitionMetrics: {
    totalRecordsCount: 0,
    completedRecordsCount: 0,
    openedRecordsCount: 0
  },
  coachingMetrics: {
    totalRecordsCount: 0,
    completedRecordsCount: 0,
    openedRecordsCount: 0
  },
  employeeIssues: [] as Issue[],
  employeeFeedback: [] as Feedback[]
};

export default TaskContext;
